var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalInvoices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 92,
    viewBox: "0 0 219 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1785_47)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 210,
    height: 84,
    rx: 8,
    fill: "#6FBD43"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_d_1785_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207 84C211.418 84 215 80.4183 215 76V38.3939C215 31.4013 206.66 27.7741 201.545 32.5421L197.111 36.6749C196.253 37.4751 195.229 38.0767 194.112 38.4369L180.431 42.8491C178.404 43.5026 176.201 43.3214 174.309 42.3457L162.013 36.0058C158.86 34.3798 155.012 35.0251 152.562 37.5909L142.456 48.172C140.156 50.5806 136.604 51.312 133.539 50.0083L124.347 46.0979C121.239 44.7757 117.635 45.548 115.342 48.0277L104.803 59.4234C101.998 62.4561 97.3458 62.8548 94.066 60.3435L84.0319 52.6605C82.2657 51.3082 80.0163 50.7523 77.8236 51.1262L63.7835 53.5204C62.3772 53.7602 61.0606 54.3717 59.9702 55.2915L46.2533 66.862C44.088 68.6885 41.1182 69.2337 38.4454 68.2954L27.0959 64.3114C25.0535 63.5945 22.8078 63.7357 20.8713 64.703L7.71537 71.2743C5.4385 72.4116 4 74.7381 4 77.2832C4 80.9928 7.00721 84 10.7168 84H207Z",
    fill: "url(#paint0_linear_1785_47)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1785_47",
    x: 0,
    y: 0,
    width: 218,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1785_47"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1785_47",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1785_47",
    x: 0,
    y: 30.3779,
    width: 219,
    height: 61.6221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1785_47"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1785_47",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1785_47",
    x1: 113.896,
    y1: 40.2633,
    x2: 113.926,
    y2: 84.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E72B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalInvoices);
export default __webpack_public_path__ + "static/media/TotalInvoices.a7d342ea31a051952dd117c69677d068.svg";
export { ForwardRef as ReactComponent };